module.exports = __webpack_public_path__ + "static/media/hand-card-coin.5cacdefc.svg";